import { useQuery } from "@tanstack/react-query";
import { ShortArticle } from "../models/shortArticle";
import { ArticlesApi } from "../services";
import { Link } from "react-router-dom";
import { useState } from "react";

export const Articles = () => {
    const { data: articlesData, error, isLoading } = useQuery<ShortArticle[]>({
        queryKey: ["articles"],
        queryFn: ArticlesApi.getArticles,
    });

    const [search, setSearch] = useState("");

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading users</div>;
    }

    const articles = articlesData ?? [];

    if (!articles) {
        return <div>404</div>
    }

    const filteredArticles = articles.filter(article => {
        const filterCreator = (article.creator?.name.toLowerCase() + " " + article.creator?.surname.toLowerCase()).includes(search.toLowerCase());
        const filterName = article.name.toLowerCase().includes(search.toLowerCase());
        return filterCreator || filterName;
    })

    return (
        <div>
            <div className="flex flex-col relative bg-[url('../public/cats/Mendeleev_Monoid_CZ.jpg')] bg-cover bg-center p-20 bg-fixed">
                <div className="absolute inset-0 bg-black opacity-65"></div>
                <div className="flex flex-col text-center">
                    <div className="text-white z-10 text-5xl">
                        Články
                    </div>
                </div>
            </div>
            <div className="flex flex-col space-y-5 md:w-2/3 mx-auto py-5 px-3">
                <input onChange={(e) => setSearch(e.target.value)} className="border border-black p-4" placeholder="Vyhledávač" />
                {
                    filteredArticles
                        .map((article, key) => (
                        <ArticleItem article={article} key={key} />
                    ))
                }
            </div>
        </div>
    )
}

interface ArticleItemProps {
    article: ShortArticle
}

export const ArticleItem: React.FC<ArticleItemProps> = ({ article }) => {
    return (
        <Link to={`/articles/${article.articleId}`}>
            <div className="flex flex-col md:flex-row bg-[#333333] p-2  items-center justify-between">
                <div className="text-xl p-3 text-white text-center">
                    {article?.name}
                </div>
                <div className="text-xl p-3 text-white">
                    {article?.creator?.name} {article?.creator?.surname}
                </div>
            </div>
        </Link>
    )
}